import { useQuery } from "@tanstack/react-query";
import type { TApiODIN } from "@/apis/odin/apiODIN";
import { userKeys } from "@/queries/queryKeys";

export const createUserQueryHooks = ({ apiODIN }: { apiODIN: TApiODIN }) => {
    const getUserDataQueryOptions = () => ({
        queryKey: userKeys.data(),
        queryFn: async () => {
            const response = await apiODIN.getUserData();
            return response.data;
        },
    });

    const useUserDataQuery = (options?: { enabled?: boolean }) =>
        useQuery({
            ...getUserDataQueryOptions(),
            enabled: options?.enabled,
        });

    return {
        useUserDataQuery,
        getUserDataQueryOptions,
    };
};

export type TUserQueryHooks = ReturnType<typeof createUserQueryHooks>;
